UAProvisionLicencesCtrl.$inject = [
  'product',
  'users',
  'domainUuid',
  'adminApi',
  'importState',
  'validators'
]

export default function UAProvisionLicencesCtrl(
  product,
  users,
  domainUuid,
  adminApi,
  importState,
  validators
) {
  this.templateLicense = {
    product: product
  }
  if (domainUuid) {
    this.templateLicense.type = 'enterprise'
  } else {
    this.templateLicense.type = 'individual'
  }
  this.userUuids = users.map(function(u) {
    return u.uuid
  })
  this.domainUuid = domainUuid
  this.provisioning = false
  this.showError = false
  this.errorMessage = ''
  this.provision = function() {
    // double confirm
    if (
      confirm(
        'Are you sure you want to provision licenses for ' + this.userUuids.length + ' users?'
      )
    ) {
      // validate start date
      var result = validators.validateLicenseStartDate(this.templateLicense.start_date_fmt)
      if (!result.OK) {
        this.showError = true
        this.errorMessage = result.message
        return
      }

      // validate template license has all the fields
      if (
        !this.templateLicense.product ||
        !this.templateLicense.type ||
        !this.templateLicense.sub_type ||
        !this.templateLicense.start_date_fmt ||
        !this.templateLicense.end_date_fmt
      ) {
        this.showError = true
        this.errorMessage = 'License has missing fields.'
        return
      }

      // perform the request
      this.provisioning = true
      this.showError = false
      this.errorMessage = ''
      this.importUuid = null

      var promise
      if (domainUuid) {
        promise = adminApi.provisionLicensesForDomainUsers(
          domainUuid,
          this.userUuids,
          this.templateLicense
        )
      } else {
        promise = adminApi.provisionLicensesForConsumerUsers(this.userUuids, this.templateLicense)
      }
      promise.then(
        result => {
          this.provisioning = false
          if (result.import_uuid) {
            this.importUuid = result.import_uuid
            importState.setImportUuid(result.import_uuid)
            importState.toggleAutorefresh(1000)
            this.state = importState
          } else {
            this.showError = true
            this.errorMessage = 'Did not receive an import_uuid. Check the console'
            console.dir(result)
          }
        },
        reason => {
          console.error(reason)
          this.provisioning = false
          this.showError = true
          this.errorMessage = reason
        }
      )
    }
  }
}
